import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import Budget from '../../../widgets/budget/Budget'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchema } from '../../../redux/actions/paymentCheckForDirector'
import { startLoading, doneLoading } from '../../../utils/loading'
import pathname from '../../../constants/pathname'

export default function PaymentCheckForDirector() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchema(projectId)
      setSchema(_schema)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  const handleConfirmBudget = (_setIsLoading, _setIsError) => {
    startLoading()
    _setIsLoading(true)
    _setIsError(false)
    try {
      // const _schema = await xxxxxx(request)
      doneLoading()
      // return history.push(`${pathname.proposal.review.approveReviewer}/${projectId}`)
      return history.push(`${pathname.proposal.review.approveReviewer}`)
    } catch (e) {
      _setIsError(true)
    }
    _setIsLoading(false)
    doneLoading()
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.projectInfo} />
      <br />
      <Budget
        schema={schema.forms}
        isEditable={false}
        onClick={() => {}}
        isHidePeriodExpenses={true}
        onClickConfirmBudget={handleConfirmBudget}
      />
      <br />
    </SidebarProposal>
  )
}
